import axios from 'axios';
import store from '@/store';
import { attachTokenRefresh } from '@/utils/authInterceptors';

const SHORTCUTS_BASE_URL = process.env.VUE_APP_ENV === 'production'
  ? 'https://api.vibrant-wellness.com/v1/pricing'
  : 'https://api.vibrant-wellness.com/v1/pricing/staging';

const shortcutsService = axios.create({
  baseURL: SHORTCUTS_BASE_URL,
  timeout: 30000
});

// Request interceptor
shortcutsService.interceptors.request.use(
  (config) => {
    const token = store.getters['login/token'] || sessionStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    console.error('Request error:', error);
    return Promise.reject(error);
  }
);

// Response interceptor
shortcutsService.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.error('Response error:', error);
    if (error.response?.status === 401) {
      store.dispatch('login/handleAuthError');
    }
    return Promise.reject(error);
  }
);

attachTokenRefresh(shortcutsService);

export default shortcutsService;
